import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Observable, map, of, switchMap, tap } from 'rxjs';
import { fadeInOutAnimation } from 'src/app/animations/fade-in-out.animation';
import { DeliveryLocation } from 'src/app/api/contracts/location';
import { WeekDay } from 'src/app/api/contracts/menu';
import { OrderType } from 'src/app/api/contracts/order';
import { CartService } from 'src/app/services/cart.service';
import { ClientService } from 'src/app/services/client.service';
import { Cart, CartItem } from 'src/app/types/cart';
import { WeekIndex } from 'src/app/types/menu';
import {
  getCurrentWeekNumber,
  getNextWeekNumber,
} from 'src/app/utils/date.utils';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
  animations: [fadeInOutAnimation()],
})
export class CartComponent implements OnInit {
  public readonly cartItems$: Observable<CartItem[]>;
  public readonly cart$: Observable<Cart>;
  public readonly subtotal$: Observable<number> = of(0);
  public readonly total$: Observable<number> = of(0);
  public readonly shippingPrice$: Observable<number> = of(0);
  public readonly deliveryLocation$: Observable<DeliveryLocation>;
  public readonly weeksNumbersInOrder$: Observable<Set<number>>;

  public readonly ORDER_TYPES = OrderType;

  constructor(
    private readonly navCtrl: NavController,
    public readonly cartService: CartService,
    private readonly clientService: ClientService
  ) {
    this.cartItems$ = this.cartService.currentCart$.pipe(
      map((cart) => cart.items)
    );

    this.cart$ = this.cartService.currentCart$;

    this.deliveryLocation$ = this.clientService.clientLocation$;
    this.shippingPrice$ = this.cartService.shippingPrice$;

    this.total$ = this.cartService.totalPrice$;

    this.weeksNumbersInOrder$ = this.cart$.pipe(
      map((cart) => cart.items.map((item) => item.weekNumber!)),
      map((weekNumbers: Array<number>) => new Set(Object.values(weekNumbers)))
    );
  }

  ngOnInit() {
    return;
  }

  onCheckoutClick() {
    this.cartService.removeNotAvailableItemsItems().subscribe(() => {
      this.navCtrl.navigateForward('order-summary');
    });
  }

  onRemoveProduct(item: CartItem): void {
    this.cartService.removeItemFromCart(item);
  }

  onIncreaseAmount(item: CartItem): void {
    this.cartService.increaseAmount(item);
  }

  onDecreaseAmount(item: CartItem): void {
    this.cartService.decreaseAmount(item);
  }
}
